import {useEffect} from "react";
import {useQuery} from "@tanstack/react-query";

import {setStorageItem} from "@/lib/utils";
import useHasPermission from "@/src/hooks/useHasPermission";

import {darsService} from "../services";

export default function useDarCodes() {
  const hasPermission = useHasPermission("dar store");

  const {data, isSuccess, isPending, isError} = useQuery({
    queryKey: ["darcodes"],
    queryFn: () => darsService.getDarCodes(),
    enabled: hasPermission,
    retry: false,
    staleTime: Infinity,
    refetchInterval: false,
  });

  useEffect(() => {
    if (isSuccess && data) {
      setStorageItem("dailyActivityReportCodes", data);
    }
  }, [isSuccess, data]);

  return {
    dailyActivityReportCodes: hasPermission && isSuccess && data ? data : [],
    isSuccess: hasPermission ? isSuccess : true,
    isPending: hasPermission && isPending,
    isError,
  };
}
